import constants from 'vets-json-schema/dist/constants.json';

const PHILIPPINES_OPTION = {
  label: 'Philippines',
  value: 'PH',
};

const EXCLUDED_FACILITY_STATE_CODES = new Set([
  'PW',
  'MH',
  'FM',
  'AA',
  'AE',
  'AP',
]);

const normalizeStateOption = option => ({
  label: option?.label || option?.name || option?.value || '',
  value: String(option?.value || '')
    .trim()
    .toUpperCase(),
});

const uniqueStateOptions = new Map(
  [...(constants?.states?.USA || []), PHILIPPINES_OPTION]
    .map(normalizeStateOption)
    .filter(
      option =>
        option.label &&
        option.value &&
        !EXCLUDED_FACILITY_STATE_CODES.has(option.value),
    )
    .map(option => [option.value, option]),
);

export const VHA_FACILITY_STATE_OPTIONS = [...uniqueStateOptions.values()].sort(
  (firstOption, secondOption) =>
    firstOption.label.localeCompare(secondOption.label, undefined, {
      sensitivity: 'base',
    }),
);

export const VHA_FACILITY_STATE_VALUES = VHA_FACILITY_STATE_OPTIONS.map(
  option => option.value,
);

export const VHA_FACILITY_STATE_LABELS = Object.fromEntries(
  VHA_FACILITY_STATE_OPTIONS.map(option => [option.value, option.label]),
);

const facilityStateCodes = new Set(VHA_FACILITY_STATE_VALUES);

export const normalizeVhaFacilityState = value =>
  String(value || '')
    .trim()
    .toUpperCase();

export const isVhaFacilityStateCode = value =>
  facilityStateCodes.has(normalizeVhaFacilityState(value));

export const getVhaFacilityStateLabel = value =>
  VHA_FACILITY_STATE_LABELS[normalizeVhaFacilityState(value)] || value || '';

export const getDefaultVhaFacilityState = address => {
  const mailingState = normalizeVhaFacilityState(address?.state);
  if (isVhaFacilityStateCode(mailingState)) {
    return mailingState;
  }

  const mailingCountry = normalizeVhaFacilityState(address?.country);
  if (mailingCountry === 'PH' || mailingCountry === 'PHL') {
    return 'PH';
  }
  return '';
};

export const getPreferredVhaFacilityState = formData => {
  const selectedState = normalizeVhaFacilityState(
    formData?.vhaMedicalFacilityState,
  );

  return isVhaFacilityStateCode(selectedState)
    ? selectedState
    : getDefaultVhaFacilityState(formData?.address);
};
